import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';

import { StylableComponent, stylePropType } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';

type FieldValueProps = StylableComponent<HTMLDivElement> & {
  value?: ReactNode;
  selecting?: boolean;
  disabled?: boolean;
};

const FieldValue = React.forwardRef<HTMLDivElement, FieldValueProps>(
  (
    { className, style, value, placeholder, selecting, disabled, ...props },
    ref
  ) => {
    return (
      <div
        {...props}
        ref={ref}
        className={className}
        css={[
          {
            display: 'flex',
            padding: '2px 4px',
            alignItems: 'center',
            outline: 'none',
            borderRadius: 4,
            backgroundColor: selecting
              ? theme.colors.adskBlue100
              : 'transparent',
            color: value ? theme.colors.charcoal900 : theme.colors.charcoal500,
            ...(disabled && {
              color: theme.colors.charcoal500,
            }),
          },
          theme.typography.labelMedium,
          style,
        ]}
      >
        {value || placeholder}
      </div>
    );
  }
);

FieldValue.displayName = 'FieldValue';

FieldValue.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The value to display, should be the formatted date(s) string(s) */
  value: PropTypes.node,
  /** Whether the field is selecting the date */
  selecting: PropTypes.bool,
  /** Placeholder to display when there is no value */
  placeholder: PropTypes.string,
  /** Whether the field is disabled */
  disabled: PropTypes.bool,
};

export default FieldValue;
